import { defineAsyncComponent } from 'vue'
export default {
  anonymous: defineAsyncComponent(() => import("/opt/build/repo/layouts/anonymous.vue").then(m => m.default || m)),
  app: defineAsyncComponent(() => import("/opt/build/repo/layouts/app.vue").then(m => m.default || m)),
  blank: defineAsyncComponent(() => import("/opt/build/repo/layouts/blank.vue").then(m => m.default || m)),
  default: defineAsyncComponent(() => import("/opt/build/repo/layouts/default.vue").then(m => m.default || m)),
  footer: defineAsyncComponent(() => import("/opt/build/repo/layouts/footer.vue").then(m => m.default || m)),
  sell: defineAsyncComponent(() => import("/opt/build/repo/layouts/sell.vue").then(m => m.default || m)),
  service: defineAsyncComponent(() => import("/opt/build/repo/layouts/service.vue").then(m => m.default || m))
}